<template>
  <div class="Navbar-div">
    <div class="Navbar-logo">
      <router-link to="/">
        <img src="../assets/images/Navbar-logo.png" />
      </router-link>
    </div>
    <div class="Navbar-vlink">
      <div class="Navbar-link">
        <el-menu
          :default-active1="String(activeIndex)"
          :default-active="navIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <template v-for="(item, index) in nav">
            <template v-if="item.child.length == 0">
              <el-menu-item :index="String(index)" :key="index">
                <router-link class="Navbar-link-link" :to="item.url">{{
                  item.name
                }}</router-link>
              </el-menu-item>
            </template>
            <template v-else>
              <el-submenu :index="String(index)">
                <template slot="title"
                  ><router-link class="Navbar-link-link" :to="item.url">{{
                    item.name
                  }}</router-link></template
                >
                <template v-for="(childItem, childIndex) in item.child">
                  <el-menu-item
                    :index="`${index}-${childIndex}`"
                    :key="`${index}-${childIndex}`"
                  >
                    <router-link class="Navbar-link-link" :to="childItem.url">{{
                      childItem.name
                    }}</router-link>
                  </el-menu-item>
                </template>
              </el-submenu>
            </template>
          </template>
          <!-- <el-menu-item index="1">
            <router-link class="Navbar-link-link" to="/">首页</router-link>
          </el-menu-item>
          <el-submenu index="2">
            <template slot="title"
              ><router-link class="Navbar-link-link" to="/Products"
                >产品</router-link
              ></template
            >
            <el-menu-item index="2-1"
              ><router-link class="Navbar-link-link" to="/ProductsCenter"
                >选项1</router-link
              ></el-menu-item
            >
            <el-menu-item index="2-2"
              ><router-link class="Navbar-link-link" to="/ProductsList"
                >选项2</router-link
              ></el-menu-item
            >
            <el-menu-item index="2-3"
              ><router-link class="Navbar-link-link" to="/ProductsCenter"
                >选项3</router-link
              ></el-menu-item
            >
          </el-submenu>
          <el-menu-item index="3"
            ><router-link class="Navbar-link-link" to="/Application"
              >应用方案</router-link
            ></el-menu-item
          >
          <el-menu-item index="4"
            ><router-link class="Navbar-link-link" to="/Service"
              >服务支持</router-link
            ></el-menu-item
          >
          <el-menu-item index="5"
            ><router-link class="Navbar-link-link" to="/AboutUs"
              >关于我们</router-link
            ></el-menu-item
          > -->
        </el-menu>
      </div>
      <div class="Navbar-search" style="cursor:pointer;" @click="searchTextHandle">
        <img src="../assets/images/Navbar-search.png" />
      </div>
      <el-dialog
        title="搜索"
        :visible.sync="showSearchDialog"
        width="30%"
        :before-close="handleClose">
        <el-tabs type="card" v-model="activeName">
          <el-tab-pane label="文章搜索" name="article">
            <el-input @keyup.enter.native="linkArticleSearch" v-model="keywords" placeholder="请输入搜索内容"></el-input>
          </el-tab-pane>
          <el-tab-pane label="产品搜索" name="product">
            <el-input @keyup.enter.native="linkProductSearch" v-model="keywords" placeholder="请输入产品型号"></el-input>
          </el-tab-pane>
        </el-tabs>
        <span slot="footer" class="dialog-footer">
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import request from "../util/request";
export default {
  name: "Navbar",
  props: ["activeIndex"],
  data() {
    return {
      nav: [],
      navIndex: null,

      keywords: '',
      showSearchDialog: false,

      activeName: 'article'
    };
  },
  async mounted() {
    let nav = await request.get("/nav/list");
    this.nav = nav;
    this.navIndex = String(
      nav.findIndex((item) => item.url == this.$route.path)
    );
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    searchTextHandle() {
      this.showSearchDialog = true
    },
    handleClose(done) {
      this.keywords = ''
      done()
    },
    linkArticleSearch() {
      if(this.keywords) {
        this.showSearchDialog = false
        this.$router.push({path: '/Search', query: {keywords: this.keywords}})
      }
    },
    linkProductSearch() {
      if(this.keywords) {
        this.showSearchDialog = false
        this.$router.push({path: '/ProductsList', query: {keywords: this.keywords}})
      }
    },
  },
};
</script>

<style scoped>
.Navbar-div {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Navbar-logo {
  display: flex;
}
.Navbar-vlink {
  display: flex;
  align-items: center;
}
.Navbar-link-link {
  color: #262626 !important;
  text-decoration: none;
  padding: 0px 20px;
  font-size: 16px;
}
</style>